import {FirestoreDocSnapshotWithIdAndData} from '@coolcolduk/firebase-util';
import {mapFirestoreDocWithTimestamp} from '../_other/firestore';
import {TradeTagDb} from './tradeTagDbSchema';
import {TradeTag, tradeTagSchema} from './tradeTagSchema';

export function mapTradeTagDbToType(db: FirestoreDocSnapshotWithIdAndData<TradeTagDb>): TradeTag {
  const data = mapFirestoreDocWithTimestamp(db);
  return tradeTagSchema.parse(data);
}
